<template>
  <q-page padding>
    <div
      class="row col-12 text-brand-5"
      style="cursor: pointer"
      @click="voltar()"
    >
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />
      <p class="text-h6 text-brand-5 text-weight-bold texto-titulo">
        Detalhes do Treinamento: {{ detalhesTreinamentos.nome }}
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Nome</div>
        <q-input
          v-model="detalhesTreinamentos.nome"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Descrição</div>
        <q-input
          v-model="detalhesTreinamentos.descricao"
          readonly
          bg-color="brand-7"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Validade (dias)</div>
        <q-input
          v-model="detalhesTreinamentos.validade"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Criado Em</div>
        <q-input
          v-model="dados.data"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input"
        />
      </div>
    </div>
    <ControlePessoas
      v-if="rotaNome == 'treinamento-detalhar-pessoas'"
      :selecionados="detalhesTreinamentos.funcionarios"
      :disponiveis="listaUsuarios"
      :treinamentoId="treinamentoId"
      @paginarTabela="paginarTabelaUsuarios"
      @buscar="buscarUsuario"
      @atualizarTabela="detalharTreinamento"
    />
    <ControleGrupos
      v-if="rotaNome == 'treinamento-detalhar-grupos' && listaGruposProdutos"
      :selecionados="detalhesTreinamentos.grupos"
      :disponiveis="listaGruposProdutos"
      :treinamentoId="treinamentoId"
      @paginarTabela="paginarTabelaGrupos"
      @buscar="buscarGrupoProduto"
      @atualizarTabela="detalharTreinamento"
    />
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

import ControlePessoas from "../components/ControlePessoas.vue";
import ControleGrupos from "../components/ControleGrupos.vue";
export default {
  components: { ControlePessoas, ControleGrupos },
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();

    const treinamentoId = route.params.treinamentoId;
    const detalhesTreinamentos = ref([]);
    const dados = ref({ data: "", unidade: null });
    const rotaNome = route.name;
    const listaGruposProdutos = ref([]);
    const listaUsuarios = ref([]);
    const buscar = ref("");

    const detalharTreinamento = async () => {
      try {
        const response = await store.dispatch(
          "treinamento/detalharTreinamento",
          {
            treinamento_id: treinamentoId,
          }
        );

        detalhesTreinamentos.value = response.data;
        dados.value.data = detalhesTreinamentos.value.data_criacao
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/");
        dados.value.unidade = detalhesTreinamentos.value.unidade_id;
        if (rotaNome == "treinamento-detalhar-pessoas") {
          listarUsuarios();
          return;
        }
        listarGruposProdutos();
      } catch (error) {
        console.log(error);
      }
    };

    const listarGruposProdutos = async (page = 1, rowsNumber = 20) => {
      try {
        const response = await store.dispatch(
          "treinamento/listarGruposProdutos",
          {
            vendor_id: dados.value.unidade,
            per_page: rowsNumber,
            page: page,
            search: buscar.value,
          }
        );
        listaGruposProdutos.value = response.data.results;
      } catch (error) {
        console.log(error);
      }
    };

    const listarUsuarios = async (page = 1, rowsNumber = 20) => {
      try {
        const response = await store.dispatch("treinamento/listarUsuarios", {
          vendor_id: dados.value.unidade,
          per_page: rowsNumber,
          page: page,
          search: buscar.value,
        });
        listaUsuarios.value = response.data.results;
      } catch (error) {
        console.log(error);
      }
    };

    const paginarTabelaGrupos = (page, rowsNumber) => {
      listarGruposProdutos(page, rowsNumber);
    };

    const paginarTabelaUsuarios = (page, rowsNumber) => {
      listarUsuarios(page, rowsNumber);
    };

    const buscarGrupoProduto = (busca) => {
      buscar.value = busca;
      listarGruposProdutos();
    };

    const buscarUsuario = (busca) => {
      buscar.value = busca;
      listarUsuarios();
    };

    const voltar = () => {
      router.push({ name: "treinamento-criar-listar" });
    };

    onMounted(detalharTreinamento);

    return {
      detalharTreinamento,
      detalhesTreinamentos,
      dados,
      rotaNome,
      listarGruposProdutos,
      listaGruposProdutos,
      paginarTabelaGrupos,
      buscarGrupoProduto,
      buscar,
      treinamentoId,
      listarUsuarios,
      listaUsuarios,
      buscarUsuario,
      paginarTabelaUsuarios,
      voltar,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 18px !important;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
}
</style>
